import type { TargetFormData } from "./types";
import { ANNUAL_PATH_OPTIONS, TARGET_LEVELS, TARGET_TYPES } from "./types";

export const LEVEL_OPTIONS = TARGET_LEVELS.map((level) => ({ label: level, value: level }));

export const TARGET_TYPE_OPTIONS = [
  { label: TARGET_TYPES.PERCENT_REDUCTION, value: TARGET_TYPES.PERCENT_REDUCTION },
  { label: TARGET_TYPES.ABSOLUTE_TCO2E, value: TARGET_TYPES.ABSOLUTE_TCO2E },
];

export const ANNUAL_PATH_RADIO_OPTIONS = [
  { label: ANNUAL_PATH_OPTIONS.EVEN, value: ANNUAL_PATH_OPTIONS.EVEN },
  { label: ANNUAL_PATH_OPTIONS.CUSTOM, value: ANNUAL_PATH_OPTIONS.CUSTOM },
];

export const ENTITY_ITEMS_PER_PAGE = 30;

export const defaultFormValues: TargetFormData = {
  targetLevel: "",
  entity: "",
  targetType: TARGET_TYPES.PERCENT_REDUCTION,
  emissionsScope: "",
  baselineYear: null,
  targetYear: null,
  targetValue: "",
  annualTargetPath: ANNUAL_PATH_OPTIONS.EVEN,
  customAnnualValues: {},
  notes: "",
};
